import axios from 'axios';
import { LOCAL_STORAGE_USER } from '../configs/constants';

export const sendFileData = async (file, uploadPath) => {
    try {
        const formData = new FormData();

        formData.append('file', file);

        const formattedPath =
            uploadPath.charAt(0) === '/' ? uploadPath : `/${uploadPath}`;
        const url = process.env.REACT_APP_CMS_API_PATH + formattedPath;

        const user = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER));

        if (!user || !user.accessToken) {
            throw new Error('User or token not found in localStorage');
        }

        const token = user.accessToken;
        console.log('url iim yvjin', url);

        const response = await axios({
            method: 'POST',
            url: url,
            data: formData,
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'multipart/form-data',
            },
        });

        return response.data;
    } catch (error) {
        console.error('Error uploading file:', error);
        throw error;
    }
};
